import {LoanTypeFilterComponent} from "./components/loan_type_filter/LoanTypeFilterComponent";
import {CustomerFilterParametersServiceName} from "../utils/names/serviceNames";
import {CustomerFilterParametersService} from "./service/CustomerFilterParametersService";
import {LoanPurposeFilterComponent} from "./components/loan_purpouse_filter/LoanPurposeFilterComponent";
import {LoanAmountSliderFilterComponent} from "./components/loan_amount_slider/LoanAmountSliderFilterComponent";
import {MultiEmployeeBranchSelector} from "./components/employee_branch_selector/multiEmployeeBranchSelector";
import {SingleEmployeeBranchSelector} from "./components/employee_branch_selector/singleEmployeeBranchSelector";
import {FilterComponentsModuleConfiguration} from "./FilterComponentsModuleConfiguration";
import {BasicFilterComponent} from "./components/filter/BasicFilterComponent";
import {
    StatusSelector
} from "modules/filter_components/components/status-picker/StatusSelector";
import {StateSelector} from "modules/customers/component/filters/state-selector";


FilterComponentsModuleConfiguration
    .createNewModule()
    .component('multiEmployeeBranchSelector', MultiEmployeeBranchSelector.instance)
    .component('statusSelector', StatusSelector.instance)
    .component('singleEmployeeBranchSelector', SingleEmployeeBranchSelector.instance)
    .component('loanTypeFilter', LoanTypeFilterComponent.instance)
    .component('loanPurposeFilter', LoanPurposeFilterComponent.instance)
    .component('loanAmountFilter', LoanAmountSliderFilterComponent.instance)
    .component('basicFilter', BasicFilterComponent.instance)
    .component('stateSelector', StateSelector.instance)
    .service(CustomerFilterParametersServiceName, CustomerFilterParametersService.instance);
